/**
 * useMasterPortalRole — portail Master dominant du collaborateur connecté
 * (rectorium_team_members.master_portal_role, Phase 1 portalisation).
 *
 * Retourne { portalRoleId, loaded } : portalRoleId = null → aucun rôle
 * explicite assigné (transitoire, cf. MasterRoleUnassignedBanner) ; sinon
 * un des 9 ids de masterPortals.MASTER_PORTALS.
 * Même pattern de cache que useMasterAccessScope.js (une seule requête par
 * session, invalidée au changement d'auth ou après une affectation de rôle).
 */
import { createMasterTeamFieldHook } from './masterTeamFieldCache';

const [useMasterPortalRole, invalidateMasterPortalRoleCache] = createMasterTeamFieldHook({
  column: 'master_portal_role',
  resultKey: 'portalRoleId',
  mapValue: (raw) => raw || null,
  defaultValue: null,
});

export default useMasterPortalRole;
/** Invalide le cache (après une affectation de rôle approuvée dans l'Annuaire, ou au logout). */
export { invalidateMasterPortalRoleCache };
